import React, { useState, useEffect } from 'react';
import { Modal, Button, ButtonGroup } from 'react-bootstrap';

export default function TurnModal({
  show,
  onHide,
  options,
  initialSelected,
  turnCost,
  userPoints,
  onConfirm
}) {
  const [selected, setSelected] = useState(initialSelected);
  const [showCustom, setShowCustom] = useState(false);
  const [custom, setCustom] = useState('');

  useEffect(() => {
    setSelected(initialSelected);
    setShowCustom(false);
    setCustom('');
  }, [initialSelected, show]);

  const handleCustomChange = e => {
    const v = e.target.value;
    if (/^\d*$/.test(v)) {
      setCustom(v);
      if (v && parseInt(v) > 0) setSelected(parseInt(v));
    }
  };

  const totalCost = selected * turnCost;

  return (
    <Modal show={show} onHide={onHide} centered style={{ zIndex: 9999 }}>
      <Modal.Header closeButton>
        <Modal.Title>🎰 选择转数</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ButtonGroup style={{ flexWrap: 'wrap', gap: '10px' }}>
          {options.map(o => (
            <Button
              key={o.value}
              variant={selected === o.value ? 'info' : 'outline-info'}
              onClick={() => setSelected(o.value)}
            >
              {o.label}
            </Button>
          ))}
          <Button
            variant={showCustom ? 'warning' : 'outline-warning'}
            onClick={() => setShowCustom(!showCustom)}
          >
            ✏️ 自定义
          </Button>
        </ButtonGroup>
        {showCustom && (
          <div style={{ marginTop: '10px' }}>
            <input
              type="text"
              value={custom}
              onChange={handleCustomChange}
              placeholder="输入转数"
            />
          </div>
        )}
        <div style={{ marginTop: '15px' }}>
          💰 总费用: {totalCost.toFixed(1)} 分
        </div>
        <div>
          💎 我的积分: {userPoints.toFixed(1)} 分
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          ❌ 取消
        </Button>
        <Button
          variant="success"
          onClick={() => onConfirm(selected)}
          disabled={userPoints < totalCost}
        >
          ✅ 确认开始
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
